export default __webpack_public_path__ + "static/media/upload.1e1eb135.svg";